<div *ngIf="isloader" class="h-100 w-100 padt-5">
    <mat-progress-bar [mode]="'indeterminate'">
    </mat-progress-bar>
</div>
<div class="d-grid" *ngIf="!isloader && !isError">
    <div class="vehicle-profile-header info-icon-align position-relative">
        <div>
            <div>{{widgetData?.title}}</div>
        </div>
    </div>


    <div class="d-flex flex-column canadapost-tagging-details-list">
        <div class="device-font-class mb-2"><span class="cp-tag-details"> Destination :</span>
            <span *ngIf="tagDetails?.destination?.name">{{tagDetails?.destination?.name}}</span>
            <span *ngIf="!tagDetails?.destination?.name">NA</span>
        </div>
        <div class="device-font-class mb-2"><span class="cp-tag-details">Lane ID :</span>
            <span *ngIf="tagDetails?.zones?.length">
                <span *ngFor="let lane of tagDetails?.zones">{{lane?.name}}</span>
            </span>
            <span *ngIf="!tagDetails?.zones?.length">NA</span>
        </div>
        <div class="device-font-class mb-2"><span class="cp-tag-details">Tagged On :</span>
            <span *ngIf="tagDetails?.taggedOn">{{tagDetails?.taggedOn | date :'short'}}</span>
            <span *ngIf="!tagDetails?.taggedOn">NA</span>
        </div>
        <div class="device-font-class mb-2"><span class="cp-tag-details">Tagged By :</span>
            <span *ngIf="tagDetails?.taggedBy">{{tagDetails?.taggedBy}}</span>
            <span *ngIf="!tagDetails?.taggedBy">NA</span>
        </div>
    </div>
    <div class="d-flex align-items-end">
        <div class="ml-auto button-cp-bg">
            <div mat-button (click)="tagMonotainer();$event.stopPropagation();"
                [ngClass]="{ 'tagDisabled' : !tagDetails?.mappingId || tagDetails?.properties?.state === 'inside'|| tagDetails?.properties?.state === 'mismatch'|| tagDetails?.properties?.state === 'delayed'|| tagDetails?.properties?.state === 'init_mismatch'}"
                class="d-grid m-0 px-0 justify-content-center w-100"><img src="../../assets/images/monotainer-tag.svg"
                    class="d-grid h-27 cursor hover-color" title="Tag/Untag" alt="Tag/Untag">
            </div>
        </div>
    </div>
</div>